module.exports = __webpack_public_path__ + "img/owner-info-bg.c9cc5277.png";